import React from "react"

import styles from "./hamburgerButton.module.scss"

const HamburgerButton = ({ onClick }) => (
  <button
    className={styles.root}
    onClick={onClick}
    aria-label={"Mobile Navigation Menu"}
  >
    <svg className={styles.svg} viewBox="0 0 24 24">
      <path fill="#000000" d="M3,6H21V8H3V6M3,11H21V13H3V11M3,16H21V18H3V16Z" />
    </svg>
  </button>
)

export default HamburgerButton
